export default "__VITE_ASSET__BasjnTRD__"